<div class="toggle-wrapper">
  <div class="switch">
    <label>
      <input
        [disabled]="false"
        [checked]="isContentEditableEnabled$ | async"
        (change)="toggle()"
        class="switch-input"
        name="principalContact"
        type="checkbox"
      />
      <div><div></div></div>
    </label>
  </div>
  <span (click)="toggle()" translationEditableDirective="TRANSLATION_TOGGLE">{{
    'TRANSLATION_TOGGLE' | translate
  }}</span>
</div>
